import React, { useState, useEffect } from "react";
import { Button, Divider, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import axios from "axios"
import { Auth } from "aws-amplify";
import { CSVLink } from "react-csv";
import { useTranslation, Trans } from "react-i18next";

import FilterListIcon from '@mui/icons-material/FilterList';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import Table from "../../TableComponent";

const Students = ({facInfo}) => {
  const [loading, setLoading] = useState(true)
  const [studentsData, setStudentsData] = useState([])
  const [std, setStd] = useState("");
  const [divn, setDivn] = useState("");
  const [school, setSchool] = useState("");

  const { t } = useTranslation();
  
  useEffect(() => {
    Auth.currentSession()
    .then((data) => {
      const jwtToken = data.idToken.jwtToken;
      
      const getStudentsData = async(facId, schoolId) => {
        try {
          const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/facilitator/"+facId+"/students?schoolId="+schoolId, {
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': jwtToken
              }
          });
          // console.log("Students Data: ",response.data["students"])
          let cwsnLabels = {
            99: "Not Applicable",
            1: "1-Blindness",
            2: "2-Low-Vision",
            3: "3-Hearing impairment",
            4: "4-Speech and Language",
            5: "5-Locomotor Disability",
            6: "6-Mental illness",
            7: "7-Specific Learning Disabilities",
            8: "8-Cerebral palsy",
            9: "9-Autism Spectrum Disorder",
            10: "10-Multiple Disability incl. deaf blindness",
            11: "11-Leprosy Cured students",
            12: "12-Dwarfism",
            13: "13-Intellectual Disability",
            14: "14-Muscular Dystrophy",
            15: "15-Chronic Neurological conditions",
            16: "16-Multiple Sclerosis",
            17: "17-Thalassemia",
            18: "18-Haemophilia",
            19: "19-Sickle Cell disease",
            20: "20-Acid Attack victim",
            21: "21-Parkinson's disease",
          }
          // adding full name by combining firstName and lastName
          const studentsData = response.data["students"].map(item => ({
            ...item, 
            "studentName": item["studentName"].toUpperCase(),
            "classSection": item["std"] + "-" + item["divn"],
            "cwsn": cwsnLabels[item["cwsn"]]
          }))
          setStudentsData(studentsData)
          setLoading(false)
        }
        catch (error) {
          console.log(error)
          setLoading(false)
        }
      }

      const facId = facInfo.facilitator[0].facId;
      const schools = facInfo.facilitator[0].schools
      // getting first school in alphabetical order same as shown in select school dropdown
      const schoolId = schools.filter(item => item.name === schools.map(item => item.name).sort()[0])[0].id;
      setSchool(schools.map(item => item.name).sort()[0])
      // console.log("facId and schoolId: ", facId, schoolId)
      getStudentsData(facId, schoolId)
      
    })
    .catch((err) => console.log(err));
    
  }, [facInfo]);
  
  const columns = [
    {
      key: "studentName",
      headerName: t("commonItems.tableHeader_studentName"),
      width: 80
    },
    {
      key: "orgStudId",
      headerName: t("commonItems.tableHeader_orgStudId"),
      width: 80
    },
    // {
    //   key: "penNo",
    //   headerName: "Student PEN",
    //   width: 80
    // },
    // {
    //   key: "std",
    //   headerName: "Class",
    //   width: 30
    // },
    // { 
    //   key: "divn", 
    //   headerName: "Section", 
    //   width: 30 
    // },
    { 
      key: "classSection", 
      headerName: t("commonItems.tableHeader_classSection"), 
      width: 30 
    },
    { 
      key: "rollNo", 
      headerName: t("commonItems.tableHeader_rollNo"), 
      width: 30 
    },
    { 
      key: "gender", 
      headerName: t("commonItems.tableHeader_gender"), 
      width: 30 
    },
    { 
      key: "cwsn", 
      headerName: t("commonItems.tableHeader_cwsnCategory"), 
      width: 80 
    },
  ];

  const headers = [
    { label: "Org Student Id", key: "orgStudId"},
    { label: "Class", key: "std" },
    { label: "Section", key: "divn" },
    { label: "Full Name of Student", key: "studentName" },
    { label: "Gender", key: "gender" },
    // { label: "Student PEN (Maximum 12 digit)", key: "penNo"},
    { label: "Roll No", key: "rollNo" },
    { label: "CWSN Category", key: "cwsn" }
  ];
  
  const handleStdChange = (e) => {
    setStd(e.target.value);
  };
  
  const handleDivnChange = (e) => {
    setDivn(e.target.value);
  };

  const handleSchoolChange = (e) => {
    setStd("");
    setDivn("");
    setStudentsData([])
    setSchool(e.target.value);
    if(e.target.value!==""){
      setLoading(true)
      const facId = facInfo.facilitator[0].facId;
      const schoolId = facInfo.facilitator[0].schools.filter(item => item.name === e.target.value)[0].id
      Auth.currentSession()
      .then((data) => {
        const jwtToken = data.idToken.jwtToken;
        
        const getStudentsData = async(facId, schoolId) => {
          try {
            const response =  await axios.get("https://zk1128nq2f.execute-api.ap-south-1.amazonaws.com/alpha/facilitator/"+facId+"/students?schoolId="+schoolId, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': jwtToken
                }
            });
            // console.log("Students Data: ",response.data["students"])
            let cwsnLabels = {
              99: "Not Applicable",
              1: "1-Blindness",
              2: "2-Low-Vision",
              3: "3-Hearing impairment",
              4: "4-Speech and Language",
              5: "5-Locomotor Disability",
              6: "6-Mental illness",
              7: "7-Specific Learning Disabilities",
              8: "8-Cerebral palsy",
              9: "9-Autism Spectrum Disorder",
              10: "10-Multiple Disability incl. deaf blindness",
              11: "11-Leprosy Cured students",
              12: "12-Dwarfism",
              13: "13-Intellectual Disability",
              14: "14-Muscular Dystrophy",
              15: "15-Chronic Neurological conditions",
              16: "16-Multiple Sclerosis",
              17: "17-Thalassemia",
              18: "18-Haemophilia",
              19: "19-Sickle Cell disease",
              20: "20-Acid Attack victim",
              21: "21-Parkinson's disease",
            }
            // adding full name by combining firstName and lastName
            const studentsData = response.data["students"].map(item => ({
              ...item, 
              "studentName": item["studentName"].toUpperCase(),
              "classSection": item["std"] + "-" + item["divn"],
              "cwsn": cwsnLabels[item["cwsn"]]
            }))
            setStudentsData(studentsData)
            setLoading(false)
          }
          catch (error) {
            console.log(error)
            setLoading(false)
          }
        }
        getStudentsData(facId, schoolId)
      })
      .catch((err) => console.log(err));
    }
  };
  
  var counts = {
    studentCount: 0,
    ...facInfo.test.lang.sort().reduce((acc, lang) => {
      acc[`${lang}RecCount`] = 0; // Create a key for each language with value 0
      return acc;
    }, {})
  };
  // var counts = {studentCount: 0, enRecCount: 0, hiRecCount: 0}
  if(facInfo && facInfo.test && school) {
    var filteredSchoolFacInfo = facInfo.facilitator[0].schools.filter(item => item.name === school)[0].classes
    var filteredClassFacInfo = filteredSchoolFacInfo
    
    if(std!=="" && divn==="") filteredClassFacInfo = filteredSchoolFacInfo.filter(item => item.std === std)
    else if(std==="" && divn!=="") filteredClassFacInfo = filteredSchoolFacInfo.filter(item => item.divn === divn)
    else if(std!=="" && divn!=="") filteredClassFacInfo = filteredSchoolFacInfo.filter(item => item.std === std && item.divn === divn)
  
    let langs = facInfo.test.lang.sort()
    counts.studentCount = filteredClassFacInfo.reduce((acc, item) => {
      return acc + item.counts[langs[0]].studentCount
    }, 0)
    
    langs.forEach(lang => {
      counts[`${lang}RecCount`] = filteredClassFacInfo.reduce((acc, item) => {
      return acc + item.counts[lang].recCount
    }, 0)
    });
  }
  // console.log(counts)
  
  var filteredStudentsData
  if(std==="" && divn===""){
    filteredStudentsData = studentsData
    // filteredSchoolFacInfo
  }
  else if(std!=="" && divn===""){
    filteredStudentsData = [...studentsData.filter(item => item.std === std)]
  }
  else if(std==="" && divn!==""){
    filteredStudentsData = [...studentsData.filter(item => item.divn === divn)]
  }
  else{
    filteredStudentsData = [...studentsData.filter(item => item.std === std && item.divn === divn)]
  }
  // console.log(studentsData)
  // console.log(filteredStudentsData)

  return (
    <div className="studentsContent innerContent">
      <h2 style={{textAlign: "center", color: "#0288D1", borderRadius: "15px", border: "1px solid"}}>
        {t("facilitator.students.title")}{facInfo.test ? <span> - {facInfo.test.testName}</span>: ""}
      </h2>
      {(facInfo.test && facInfo.test.superAdminId===24) && 
        <>
          <h4 style={{ paddingTop:"1rem", color: "#dc3545"}}>
            <Trans 
              i18nKey={"facilitator.students.studentAdditionInfo_Line1KV"}
              values={{
                date: new Date(facInfo.test.studListUpdateDate).toLocaleDateString("en-GB", { dateStyle: "long" })
              }}
              components={{
                1: <span style={{color: "var(--text-color)", fontWeight: "normal"}}/>
              }}
            />
          </h4>
          <h4 style={{color: "var(--text-color)", fontWeight: "normal"}}>
            {t("facilitator.students.studentAdditionInfo_Line2KV")}
          </h4>
        </>
      }
      {/* {(facInfo.test && facInfo.test.status===0) && 
        <h4 style={{paddingTop:"1rem", color: "#dc3545"}}>
          Students can only be added from the principal's login. Once the students have been added, they will be visible here but not in the App. Last date to finalize student list is {new Date(facInfo.test.tentativeStartDate).toLocaleDateString("en-GB", { dateStyle: "long" })} after which the student list will also be visible in the App.
        </h4>
      } */}
      <div className="countTileContainer">
        <div className="countTile">
          <div className="countTileLeft">{t("commonItems.countTile_StudentCount")}:</div>
          <div className="countTileRight">{counts.studentCount.toLocaleString("hi")}</div>
        </div>
        {facInfo && facInfo.test &&
          facInfo.test.lang.sort().map((lang, i) => {
            return <div className="countTile" key={i}>
                    <div className="countTileLeft">{t("commonItems.countTile_TestedCount")} - {facInfo.allLangs[lang]}:</div>
                    <div className="countTileRight">{counts[`${lang}RecCount`].toLocaleString("hi")}</div>
                  </div>
          })
        }
      </div>
      <div className="filters">
        <div className="forms">
          <h4 style={{display: "flex", justifyContent: "center", alignItems: "center", gap: "0.25rem"}}>
            <FilterListIcon fontSize="small"/>
            <span style={{height: "100%"}}>{t("commonItems.filterLabel")}</span> 
          </h4>
          <FormControl sx={{ m: 1, minWidth: 100 }} size="small">
            <InputLabel id="schoolFilterLabel">{t("commonItems.dropdownLabel_school")}</InputLabel>
            <Select
              labelId="schoolFilterLabel"
              id="schoolFilter"
              value={school}
              onChange={handleSchoolChange}
              autoWidth
              label={t("commonItems.dropdownLabel_school")}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {/* getting all unique divn values from data */}
              { facInfo &&
                [...new Set(facInfo.facilitator[0].schools.map(item => item.name))].sort().map((item, i) => {
                return <MenuItem key={i} value={item}>{item}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 85}} size="small">
            <InputLabel id="stdFilterLabel">{t("commonItems.dropdownLabel_class")}</InputLabel>
            <Select
              labelId="stdFilterLabel"
              id="stdFilter"
              value={std}
              onChange={handleStdChange}
              autoWidth
              label={t("commonItems.dropdownLabel_class")}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {/* getting all unique std values from data */}
              {divn==="" &&
                [...new Set(studentsData.map(item => item.std))].sort((a, b) => a - b).map((item, i) => {
                return <MenuItem key={i} value={item}>{item}</MenuItem>
                })
              }
              {divn!=="" &&
                [...new Set(studentsData.filter(item => item.divn === divn).map(item => item.std))].sort().map((item, i) => {
                return <MenuItem key={i} value={item}>{item}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 100 }} size="small">
            <InputLabel id="divnFilterLabel">{t("commonItems.dropdownLabel_section")}</InputLabel>
            <Select
              labelId="divnFilterLabel"
              id="divnFilter"
              value={divn}
              onChange={handleDivnChange}
              autoWidth
              label={t("commonItems.dropdownLabel_section")}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {/* getting all unique divn values from data */}
              {std==="" &&
                [...new Set(studentsData.map(item => item.divn))].sort().map((item, i) => {
                return <MenuItem key={i} value={item}>{item}</MenuItem>
                })
              }
              {std!=="" &&
                [...new Set(studentsData.filter(item => item.std === std).map(item => item.divn))].sort().map((item, i) => {
                return <MenuItem key={i} value={item}>{item}</MenuItem>
                })
              }
            </Select>
          </FormControl>
        </div>
      </div>
      <div className="tabs">
        <Button variant="contained" color="info" startIcon={<FileDownloadIcon />} sx={{ placeSelf: "start" }}>
          <CSVLink data={studentsData.filter(item => item.rollNo !== 0)} headers={headers} filename={"StudentsData.csv"}>
            {t("commonItems.buttonLabel_csvDownload")}
          </CSVLink>
        </Button>
      </div>
      <Divider />
      <div className="table">
        <Table
          columns={columns}
          tableData={filteredStudentsData}
          orderBy={["rollNo"]}
          tableHeight={(facInfo.test && facInfo.test.superAdminId===24) ? "calc(100vh - 453px)" : "calc(100vh - 390px)"} 
          loading={loading}
        />
      </div>
    </div>
  );
};

export default Students;
